



import React, { useState } from 'react';
import {
    AddContainer, Component4, Texts, InputTextComponent,
    PrescriptionViewBox, PresText, PresTitle, EditButton, SaveButton, Component6, LabelWithTooltip
} from './Styles';
import { Formik, Form } from 'formik';
import {
    Box, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import { ReactComponent as Close } from '../../../../../assets/images/close-circle.svg';
import theme from 'src/config/theme';
import SwitchComponent from 'src/components/shared/Form/Switch';
import NumberInput from 'src/components/shared/Form/Number';
import useResponsive from 'src/components/hooks/useResponsive';

const ServicesStep = ({ innerRef, data, setClinicProfileData }) => {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '20px';
    const Height = isMobile || isTablet ? '18px' : '20px';
    const [selectedService, setSelectedService] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [localServices, setLocalService] = useState(data || []);
    const initialValues = {
        name: selectedService?.name || '',
        value: selectedService?.value || '',
        fees: selectedService?.fees || '',
        showInPublic: selectedService?.showInPublic === "yes"
    };
    const handleEdit = (service) => {
        setSelectedService(service);
        setOpenDialog(true);
    };
    const handleDelete = (servicesToDelete) => {
        const updatedServices = localServices.filter(
            f => !(f.name === servicesToDelete.name && f.value === servicesToDelete.value)
        );
        setLocalService(updatedServices);
        setClinicProfileData(prev => ({
            ...prev,
            services: updatedServices,
        }));
    };
    const handleAdd = () => {
        setSelectedService(null);
        setOpenDialog(true);
    };

    const handleSubmit = (values, { resetForm }) => {
        if (!values.name.trim() || !values.value.trim()) return;

        setLocalService(prev => {
            const isEditing = !!selectedService;
            let updated;

            if (isEditing) {
                updated = prev.map(f =>
                    f.name === selectedService.name &&
                        f.value === selectedService.value &&
                        f.fees === selectedService.fees
                        ? {
                            name: values.name,
                            value: values.value,
                            fees: values.fees,
                            showInPublic: values.showInPublic ? "yes" : "no",
                        }
                        : f
                );
            }
            else {
                const duplicate = prev.find(
                    f => f.name.trim().toLowerCase() === values.name.trim().toLowerCase() &&
                        f.value.trim().toLowerCase() === values.value.trim().toLowerCase() &&
                        f.fees.trim().toLowerCase() === values.fees.trim().toLowerCase()
                );
                if (duplicate) return prev;

                updated = [...prev, {
                    name: values.name, value: values.value, fees: values.fees, showInPublic: values.showInPublic ? "yes" : "no"
                }];
            }
            setClinicProfileData(prevData => ({
                ...prevData,
                services: updated,
            }));

            return updated;
        });

        setSelectedService(null);
        setOpenDialog(false);
        resetForm();
    };


    return (
        <>
            <AddContainer>
                {localServices.map((services, index) => (
                    <PrescriptionViewBox key={index}>
                        <Box>
                            <PresTitle>{services.name}</PresTitle>
                            <PresText>{services.value}</PresText>
                            <PresText>{services.fees} ₹ </PresText>
                        </Box>
                        <Box sx={{ display: 'flex', gap: '8px' }}>
                            <EditButton onClick={() => handleEdit(services)}>
                                <Edit width={Width} />
                            </EditButton>
                            <EditButton onClick={() => handleDelete(services)}>
                                <Close width={Width} />
                            </EditButton>
                        </Box>
                    </PrescriptionViewBox>
                ))}

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <SaveButton
                        variant="outlined"
                        startIcon={<Add width={Width} height={Height} sx={{ color: theme.palette.primary.main }} />}
                        onClick={handleAdd}
                    >
                        Add
                    </SaveButton>
                </Box>
            </AddContainer>

            <Dialog
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false);
                    setSelectedService(null);
                }}
                maxWidth="md"
            >
                <DialogTitle>{selectedService ? 'Edit Service' : 'Add New Service'}</DialogTitle>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    innerRef={innerRef}
                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <DialogContent>
                                <AddContainer>

                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip
                                                label="Service Name"
                                                tooltip="Enter a name for the service you are offering."
                                            />
                                        </Texts>
                                        <InputTextComponent
                                            name="name"
                                            placeholder="Enter Service Name"
                                            variant="outlined"
                                            value={values.name}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip
                                                label="Service Value"
                                                tooltip="Mention the value or unit for the service (e.g., 30 minutes, 1 session)."
                                            />
                                        </Texts>
                                        <InputTextComponent
                                            name="value"
                                            placeholder="Enter Service Value"
                                            variant="outlined"
                                            value={values.value}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip
                                                label="Service Fees"
                                                tooltip="Specify the charge for this service."
                                            />
                                        </Texts>
                                        <NumberInput
                                            name="fees"
                                            fullWidth
                                            width="auto" height="52px"
                                            value={values.fees}
                                            onChange={(val) => setFieldValue('fees', val)}
                                        />
                                    </Component4>


                                    <Component6>
                                        <Texts>
                                            <LabelWithTooltip
                                                label="Show In Public"
                                                tooltip="Enable this to make the service visible to patients publicly."
                                            />
                                        </Texts>
                                        <SwitchComponent
                                            name="showInPublic"
                                            checked={values.showInPublic}
                                            onChange={() => setFieldValue('showInPublic', !values.showInPublic)}
                                            sx={{
                                                margin: 0,
                                                padding: 0,
                                            }}
                                        />
                                    </Component6>
                                </AddContainer>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                                <Button type="submit" variant="contained">
                                    {selectedService ? 'Update' : 'Save'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default ServicesStep;